export const CSAT = 'CSAT';
export const CUSTOM = 'CUSTOM';